import { Component, OnInit } from '@angular/core';
import { DataService } from '../core/data.service';
import { DBVersionInfo } from '../shared/models/db-version-info';

@Component({
  selector: 'app-footer',
  template: `
    <span class="copyright float-left px-2 py-1">Copyright &copy; 2009 - {{currentYear}} PDI Technologies</span>
    <span class="copyright float-left px-2 py-1" >Version : 2.0.0 </span>
    <span class="copyright float-left px-2 py-1" ><i class="fas fa-database fa " ></i> DB Version: {{dbVersion?.currentVersion}} - Required DB Version: {{dbVersion?.requiredVersion}}</span>

  `,
  styles: [`
    :host {
      display: block;
      -ms-flex: 0 0 1.875rem;
      flex: 0 0 1.875rem;
      background: linear-gradient(to top, rgba(203,203,203,1) 0%, rgba(0,0,0,0) 100%);
    }
    .copyright {
      color: #8C808C;
      font-size: 0.6875rem;
      line-height: 1.375rem;
    }
  `]
})
export class FooterComponent implements  OnInit {
  dbVersion: DBVersionInfo;
  currentYear: number;
  constructor(private dataService: DataService) { }
  ngOnInit() {
   this.currentYear = (new Date()).getFullYear();
   this.dataService.getDbVersion().then(dbVersion => {
      this.dbVersion = dbVersion;
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/layout/footer.component.ts